import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { S as StringService } from './index2.js';
import { T as TrackingService, D as DomService } from './index3.js';
import { T as TranslationService } from './index6.js';
import { A as AdobeTracking } from './index7.js';

const rocheTagCss = ":host{display:block;margin-top:3rem;margin-top:0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host{display:inline-flex}:host .tag-wrapper{transition:background-color 200ms ease, border-color 200ms ease, color 200ms ease;display:inline-flex;margin:0 1rem 1rem 0;background-color:#fff;border:1px solid #fad6c7;border-radius:3.125rem}:host .tag-wrapper:hover{background-color:#e7b198;border-color:#e7b198;box-shadow:0 0.375rem 0.75rem rgba(33, 33, 33, 0.24)}:host .tag-wrapper:active{background-color:#fad6c7;border-color:#fad6c7}:host .tag-wrapper:focus-visible:focus,:host .tag-wrapper:focus-visible:focus-visible{outline:var(--color-interactive--primary-idle) dashed 2px;outline-offset:1}:host .tag-wrapper:focus-visible:focus:not(:focus-visible){outline:none}:host .tag-wrapper:focus-visible:focus,:host .tag-wrapper:focus-visible:focus-visible{outline:var(--color-interactive--focus) dashed 2px;outline-offset:unset}:host .tag-wrapper:focus-visible:focus:not(:focus-visible){outline:none}:host .tag-wrapper:focus-visible:focus{background-color:#fad6c7}:host .tag-wrapper:focus-visible:focus-visible{background-color:#fad6c7}:host .tag-wrapper:focus:not(:focus-visible){outline:0}:host .tag-link{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-weight:400;font-size:var(--button--font-size--small-up);line-height:1.3125rem;display:block;padding:0.5rem 1rem;color:#664533;text-align:center;text-decoration:none}@media (min-width: 48rem){:host .tag-link{font-size:var(--button--font-size--medium-up);line-height:1.4375rem}}@media (min-width: 48rem){:host .tag-link{padding:0.75rem 1.5rem}}";
const RocheTagStyle0 = rocheTagCss;

const RocheTag = /*@__PURE__*/ proxyCustomElement(class RocheTag extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.trackTagClick = () => {
            TrackingService.push(this.defaultTracking);
            AdobeTracking(this.adobeTracking, 'defaultLinkClick');
        };
        this.tag = undefined;
        this.tagUrl = undefined;
        this.translations = undefined;
    }
    async componentWillLoad() {
        this.translations = {
            tag: await TranslationService.translate(this.tag, DomService.getGlobalConfig().locale, DomService.getGlobalConfig().tagsTranslationUrl),
        };
        this.tagUrl = this.getTagUrl();
    }
    getTagUrl() {
        var _a;
        const { tagPageUrl } = DomService.getGlobalConfig();
        const tagUrlfied = StringService.urlify((_a = this.translations) === null || _a === void 0 ? void 0 : _a.tag);
        return tagPageUrl && tagUrlfied ? `${tagPageUrl}/${tagUrlfied}` : '';
    }
    render() {
        return (h("div", { key: 'a3fce567fb7786d54c933c7288b479d50e4d864f', class: "tag-wrapper" }, h("a", { key: 'e0676f4fbd54696199fb2bdf38dfac4e21ce1f91', href: this.tagUrl, class: "tag-link", onClick: this.trackTagClick }, this.translations.tag)));
    }
    // eslint-disable-next-line class-methods-use-this
    get defaultTracking() {
        return {
            event: 'tag_click',
            component_name: 'roche-tag',
            additionalParameters: {
                original_tag: this.tag,
            },
            value: this.translations.tag,
        };
    }
    // eslint-disable-next-line class-methods-use-this
    get adobeTracking() {
        return {
            innerText: this.tag,
            url: this.tagUrl,
            position: 'RocheTag',
            type: 'Tag',
            socialMedia: '',
            socialInteraction: '',
        };
    }
    static get style() { return RocheTagStyle0; }
}, [1, "roche-tag", {
        "tag": [1],
        "tagUrl": [32],
        "translations": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-tag"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-tag":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheTag);
            }
            break;
    } });
}

export { RocheTag as R, defineCustomElement as d };

//# sourceMappingURL=roche-tag2.js.map